import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=5198c345&scoped=true&"
import script from "./footer.vue?vue&type=script&lang=js&"
export * from "./footer.vue?vue&type=script&lang=js&"
import style0 from "./footer.vue?vue&type=style&index=0&id=5198c345&lang=less&scoped=true&"
import style1 from "./footer.vue?vue&type=style&index=1&id=5198c345&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5198c345",
  null
  
)

export default component.exports